import { goApi } from './apiService';

let languageMapCache: Record<string, string> | null = null;
let reverseLanguageMapCache: Record<string, string> | null = null;

export async function getLanguageMap(): Promise<Record<string, string>> {
    if (languageMapCache) {
        return languageMapCache as Record<string, string>;
    }

    try {
        const response = await goApi.get('/tests-series/languages');
        languageMapCache = response?.data || {};
        return languageMapCache as Record<string, string>;
    } catch (error) {
        console.error('Error fetching language map:', error);
        return {};
    }
}

export async function getReverseLanguageMap(): Promise<Record<string, string>> {
    if (reverseLanguageMapCache) {
        return reverseLanguageMapCache as Record<string, string>;
    }

    const languageMap = await getLanguageMap();
    reverseLanguageMapCache = Object.fromEntries(
        Object.entries(languageMap).map(([name, code]) => [code, name]),
    );
    return reverseLanguageMapCache as Record<string, string>;
}

export async function codeToName(code: string): Promise<string> {
    const reverseMap = await getReverseLanguageMap();
    return reverseMap[code] || code;
}

export async function nameToCode(name: string): Promise<string> {
    const languageMap = await getLanguageMap();
    return languageMap[name] || name;
}

export async function codesToNames(codes: string[]): Promise<string[]> {
    const reverseMap = await getReverseLanguageMap();
    return codes.map(code => reverseMap[code] || code);
}

export async function namesToCodes(names: string[]): Promise<string[]> {
    const languageMap = await getLanguageMap();
    return names.map(name => languageMap[name] || name);
}

export async function getLanguageNames(): Promise<string[]> {
    const languageMap = await getLanguageMap();
    return Object.keys(languageMap);
}
